import { POA_BADGE_META, POA_BADGE_COLOR_CLASSES, type PoaBadge } from '../lib/poaStatus'

// Z73.6.1: the one badge component for POA validity, used on Job Detail, Customer Detail, POA
// Management, and eCustoms Preview -- same emoji + label + color everywhere.
export default function PoaStatusBadge({ badge, title, compact }: { badge: PoaBadge; title?: string; compact?: boolean }) {
  const meta = POA_BADGE_META[badge]
  return (
    <span
      title={title}
      className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-semibold ${POA_BADGE_COLOR_CLASSES[badge]}`}
    >
      <span>{meta.emoji}</span>
      {!compact && <span>POA {meta.label}</span>}
    </span>
  )
}
